const riot = require('riot');

riot.tag2('modal-project', '<div class="modal bg-white w472 s-w-full rounded-8 m8" ref="modal"> <form class="pt18 pb24 px16" onsubmit="{submit}" onkeydown="{selectionList.onKeyDown}"> <div class="f fm flex-between mb16"> <div class="bold fs16">{getKindName()}を{opts.project ? ⁗編集⁗ : ⁗作成⁗}</div> <div class="p4 cursor-pointer" onclick="{close}"><i class="icon-close fs24 text-label_dark_medium"></i></div> </div> <div class="mb24"> <div class="f fm mb8"> <div class="bold mr8">カラー設定</div><i class="icon-help cursor-pointer fs16 text-label_dark_primary pt1 tooltip" aria-label="プロジェクトのカラーが設定できます。※未設定の場合ランダムでカラーが設定されます。" data-tooltip-position="top"></i> </div> <button class="relative f fh w48 h32 hover-trigger hover-opacity-80"> <input class="absolute trbl0 opacity-0" ref="color" riot-value="{opts.project.data.color}" onchange="{colorChange}" type="{\'color\'}"> <div class="absolute trbl0 f fh pointer-none s-full py3 rounded-8 border border-pale"> <div class="f fh s-full rounded-2" riot-style="background-color: {colorChanged ? refs.color.value : opts.project.getColor()}"> <p class="fs10" if="{!colorChanged &amp;&amp; !opts.project}">未設定</p> </div> </div> </button> </div> <div class="f fm mb25 w-full" show="{!isDM()}"> <div class="s88 rounded-20 flex-fixed cursor-pointer overflow-hidden mr16" riot-style="background-color: {getBgColor()};"> <div class="s-full" ref="icon" data-is="atom-input-image" riot-src="{app.utils.getImageUrl(opts.project.data.icon_image)}" icon-size="48" project="{opts.project}"> <div class="f fh s-full" if="{(!url &amp;&amp; !opts.project) || !url &amp;&amp; !opts.project.data.icon_image}"><i class="icon-common fs48 {opts.project ? &quot;text-white&quot; : &quot;text-label_dark_medium&quot;}"></i></div> </div> </div> <div class="block w-full"> <div class="f fm mb8"> <div class="bold fs14 mr8">{getKindName()}名</div><i class="icon-help cursor-pointer fs16 text-label_dark_primary tooltip" aria-label="{app.data.tips.project_name}" data-tooltip-position="top"></i> </div> <div class="f fm"> <input class="input light_secondary w-full" ref="project_name" placeholder="{getKindName()}名を入力" riot-value="{getValue()}" oninput="{_.noop}" required> </div> </div> </div> <div class="block mb8"> <div class="f flex-between mb8"> <div class="f fm"> <div class="bold fs14 mr8">ユーザー一覧</div><i class="icon-help cursor-pointer fs16 text-label_dark_primary pt1 tooltip" aria-label="先頭に @ をつけるとグループ検索をすることが可能です。" data-tooltip-position="top"></i> </div> <div class="text-label_dark_medium"><span class="bold fs14">{getProjectUserCount()}</span><span class="fs12">/{workspaces_users.length} user</span></div> </div> <div class="input f fm light light_secondary pr8 pl12"><i class="icon-search text-label_dark_disabled fs16 mr8"></i> <input class="w-full" ref="search" placeholder="ユーザー または、@グループ名を検索" oninput="{debounceSearch}"><i class="icon-close fs16 cursor-pointer ml8" onclick="{onDeleteQuery}" if="{refs.search.value}"></i> </div> </div> <div class="block mb24"> <div class="border rounded-8 h222 overflow-scroll"> <div class="f fm fbw px8 py16 border-bottom" if="{group &amp;&amp; group.data.screen_name!==\'all\'}"> <div class="bold">@{group.data.screen_name}グループ</div> <button class="button primary hover-pale py4 px6 rounded-20 border fs10" type="button" onclick="{selectAllUsers}">グループ全員を選択</button> </div> <div each="{item in displayUsers}" data-is="item-selection-list" item="{item}" onclick="{onToggleCheck}" selected-class="bg-pale"> <label class="f fm py8 pr16 pl8"><i class="flex-fixed s16 fs16 bold mr8 {&quot;icon-check text-primary&quot; : item.checked}"></i> <div class="w-full" data-is="item-user" item="{item.user.relation.user}" role="{item.user.data.role}"></div> </label> </div> </div> </div> <div class="f overflow-x-scroll scrollbar-none mb24" if="{getAssignedUser().length}"> <div class="flex-fixed s24 mr4" each="{user in getAssignedUser()}" data-is="item-user-icon" user="{user}"></div> </div> <div class="mb24"> <div class="bold fs14 mb8">センシティブなセキュリティを有効にする</div> <div data-is="atom-switch" ref="sensitive" checked="{opts.project.data.is_sensitive}"></div> </div> <div class="text-center"> <button class="button w220 {canSubmit() ? \'primary hover-pale\' : \'disabled pointer-none\'}" ref="submitButton" disabled="{!canSubmit()}">{this.opts.project ? ⁗更新⁗ : ⁗作成⁗}</button> </div> </form> </div>', 'modal-project,[data-is="modal-project"]{background-color:rgba(0,0,0,0.5)} modal-project input::placeholder,[data-is="modal-project"] input::placeholder{color:rgba(29,40,76,0.2);font-size:13px} modal-project input:focus,[data-is="modal-project"] input:focus{outline:none !important}', 'class="f fh s-px8" spat-animation="push"', function(opts) {

    this.mixin('selectionList');
    this.workspaces_users = [];
    this.selectedIndex = 0;
    this.colorChanged = false;

    this.on('mount', async () => {

      let promises = [
        app.store.workspace.fetchWorkspaceUsers(),
        app.store.workspace.fetchGroups(),
      ];

      let [workspaces_users, groups] = await Promise.all(promises);
      this.groups = groups;

      if (this.opts.project) {

        let projects_users = await this.opts.project.fetchProjectUsers();

        this.workspaces_users = workspaces_users.map(workspace_user => {
          let checked = projects_users.some(project_user => {
            return project_user.id === workspace_user.relation.user.id;
          });
          return {
            checked,
            user: workspace_user,
          };
        });
      }

      else {

        this.workspaces_users = workspaces_users.map(workspace_user => {
          let checked = workspace_user.data.user_id === app.auth.currentUser.uid;
          return {
            checked,
            user: workspace_user,
          };
        });
      }

      this.displayUsers = app.utils.displayUsersSort(this.workspaces_users, (user) => user.user.relation.user);
      this.refs.project_name.focus();
      this.update();
    });

    this.submit = async (e) => {
      e.preventDefault();
      let i = spat.modal.indicator();

      let users_ids = this.workspaces_users.filter(wu => !!wu.checked).map(wu => wu.user.relation.user.id);
      let data = {
        name: this.refs.project_name.value,
        user_ids: users_ids || [],
        is_sensitive: this.refs.sensitive.checked,
        color: this.colorChanged ? this.refs.color.value : "",
      };

      if (this.isDM()) {
        let users = this.getAssignedUser();
        Object.assign(data, {
          name: users.map(user => user.data.screen_name).sort().join(','),
          workspace_id: app.store.workspace_id,
          kind: 'direct',
        });

        let project = await this.findProjects(data);
        const currentName = opts.project ? opts.project.data.name : '';
        if (currentName !== data.name && project) {
          i.close();
          return spat.modal.alert(`すでに存在するダイレクトメッセージです`);
        }
      }

      else if (!this.opts.project || this.opts.project.data.name !== this.refs.project_name.value) {

        let checked_duplicate = app.store.projectsUsersStore.items.some(item => item.data.project_name === this.refs.project_name.value);
        if (checked_duplicate) {
          i.close();
          return spat.modal.alert(`${this.refs.project_name.value}は使用されています。`);
        }

        if(!this.opts.project) {
          data.kind = "team";
        }
      }

      let url = await this.refs.icon.uploadAndGetImageURL();
      if (url) {
        data.icon_image = {
          url,
        };
      }

      try {

        this.value = await this.opts.project ? this.opts.project.update(data) : app.store.workspace.createProject(data);
        if(this.opts.project) {
          app.utils.openToast('update');
        }
        else {
          app.utils.openToast(this.isDM() ? 'createDM' : 'createProject');
        }
      }
      catch (e) {
        console.log(e.message);
        spat.modal.alert(e.message);
      }
      finally {
        i.close();
        this.close();
      }
    };

    this.onSelectImage = () => {
      alert('画像追加機能未実装');
    };

    this.onToggleCheck = (e) => {
      e.item.item.checked = !e.item.item.checked;
      this.update();
    };

    this.getProjectUserCount = () => {
      return this.workspaces_users.filter(wu => wu.checked).length;
    };

    this.debounceSearch = _.debounce(() => {
      this.group = null;
      let value = this.refs.search.value;
      if (!value) {
        this.displayUsers = this.workspaces_users;
        this.update();
        return;
      }
      else {

        this.displayUsers = [];

        let is_group_search = value.startsWith("@");

        if (is_group_search) {

          this.group = this.searchGroup(value.substring(1));
          if (this.group) {
            this.displayUsers = this.filterWorkspaceUsersByGroupUserIds(this.group);
          }
        }

        else {

          this.displayUsers = app.utils.filterUsers(this.workspaces_users, value, (user) => user.user.relation.user);
        }
        this.update();
      }
    }, 128);

    this.searchGroup = (value) => {
      if (!value) return ;
      const sorted = this.groups

        .filter(g => g.data.screen_name.includes(value))

        .sort((a, b) => a.data.screen_name.indexOf(value) - b.data.screen_name.indexOf(value));

      return sorted[0];
    };

    this.getValue = () => {

      if (this.opts.project) {
        return this.opts.project.data.name;
      }

      else if (this.opts.section.length) {
        return `${this.opts.section}/`;
      }
    };

    this.canSubmit = () => {
      let has_checked = this.workspaces_users.some(item => {
        return item.checked;
      });

      return this.refs.project_name.value.trim() && has_checked;
    };

    this.getAssignedUser = () => {
      return this.workspaces_users.filter(u => u.checked).map(u => u.user.relation.user);
    };

    this.onDeleteQuery = () => {
      this.refs.search.value = '';
      this.refs.search.focus();
      this.displayUsers = this.workspaces_users;
      this.group = null;
      this.update();
    };

    this.on('selectionList.keydown', (e) => {

      if (document.activeElement === this.refs.project_name) {

        e.preventSelectionList = true;
      }
    });

    this.on('selectionList.keydown.enter', (e) => {
      const isNotButton = document.activeElement === this.refs.submitButton;

      if (!isNotButton) {
        e.preventDefault();
        let selected_user = this.displayUsers[this.selectionList.selectedIndex];
        selected_user.checked = !selected_user.checked;
      }
    });

    this.on('selectionList.keydown.other', (e) => {

      if (document.activeElement !== this.refs.search) {

        this.refs.search.focus();
      }
    });

    this.getBgColor = () => {
      if (this.opts.project && !(this.opts.project.data.icon_image && this.opts.project.data.icon_image.url)) {
        return this.opts.project.data.color || `hsl(${app.utils.stringToColorAngle(this.opts.project.data.name)}, 60%, 60%)`;
      }
      else {
        return `#D8E0EB`;
      }
    };

    this.findProjects = async ({name, kind}) => {

      let projectsUsers = app.store.projectsUsersStore.items.filter(item => item.data.project_kind === kind);

      let projects = projectsUsers.map(pu => app.store.doc(pu.data.project_ref.path));

      let promises = projects.map(async (project) => {
        let project_users = await project.fetchProjectUsers();
        let project_name = project_users.map(user => user.data.screen_name).sort().join(',');
        if (name === project_name) {
          return project;
        }
        else {
          throw '';
        }
      });

      try {

        return await Promise.any(promises);
      }
      catch(e) {

        return ;
      }
    };

    this.getKindName = () => {
      if (this.isDM()) {
        return "ダイレクトメッセージ";
      }
      return "プロジェクト";
    };

    this.isDM = () => {
      return this.opts.isDM || (this.opts.project && this.opts.project.data.kind === "direct");
    };

    this.filterWorkspaceUsersByGroupUserIds = (mention) => {
      let group_user_ids = new Set(mention.data.user_ids);
      return this.workspaces_users.filter(wu => group_user_ids.has(wu.user.relation.user.id));
    };

    this.selectAllUsers = () => {
      let checked_count = 0;
      this.displayUsers.forEach(u => {
        if (!u.checked) {
          u.checked = true;
          ++checked_count;
        }
      });
      if (checked_count) {
        spat.toast.message(`${checked_count}人のメンバーを選択しました。`);
      }
    };

    this.colorChange = () => {
      this.colorChanged = true;
    };
});